<template>
  <IframePlayer :source-url="sourceUrl" />
</template>

<script>
import IframePlayer from './IframePlayer.vue';

export default {
  components: {
    IframePlayer
  },
  props: {
    video: { type: Object, required: true },
    autoplay: { type: Boolean, default: false }
  },
  computed: {
    sourceUrl() {
      return `${this.video.videoUrl}?autoplay=${+this.autoplay}`;
    }
  }
}
</script>
